import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";

/**
 * Simple switch with callbacks for on, off and toggle
 * @param {boolean} initial
 * @returns {[boolean function, function. function, function]}
 */
export default function useFlag() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState = useState(initial),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  return [state, function () {
    return setState(true);
  }, function () {
    return setState(false);
  }, function () {
    return setState(function (s) {
      return !s;
    });
  }, setState];
}
//# sourceMappingURL=useFlag.js.map